import { Injectable } from '@angular/core';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { DateGfDatePipe } from '../../../core/pipes/date/date.gf-date.pipe';

import * as _ from 'lodash';

@Injectable()
export class FrsReleaseChartsService {
    constructor(
        private gfTranslateService: GfTranslateService,
        private gfDatePipe: DateGfDatePipe
    ) {}

    getRemainingChartOptions() {
        return {
            chart: {
                type: 'multiBarHorizontalChart',
                height: 300,
                margin: {
                    top: 5,
                    right: 50,
                    bottom: 40,
                    left: 100
                },
                showValues: false,
                showControls: false,
                stacked: false,
                showLegend: false,
                noData: this.gfTranslateService.translate("No Data Available"),
                showXAxis: true,
                showYAxis: true,
                x(d) {
                    return d.label;
                },
                y(d) {
                    return d.value;
                },
                yAxis: {
                    // axisLabel: '# Assigned Tasks',
                    tickFormat(d) {
                        return parseInt(d);
                    }
                },
                tooltip: true
            }
        };
    }

    getRemainingChartData(release) {
        var chartData = _.filter(
            _.get(release, 'rel.remaining', []),
            function (item) {
                return (item?.unix_name ?? null) != null;
            }
        ).map(function (vals) {
            return {
                label: _.get(vals, 'unix_name', ''),
                value: _.get(vals, 'assignee_tracker_items_count', 0)
            };
        });

        return [
            {
                key: this.gfTranslateService.translate('Remaining Tasks'),
                color: '#1f77b4',
                values: chartData
            }
        ];
    }

    getBurndownChartOptions(burndown) {

        var bins = _.get(burndown, 'bins', {});
        var newMax = _.get(_.maxBy(_.values(bins), 'new'), 'new', 0);
        var closedMax = _.get(_.maxBy(_.values(bins), 'closed'), 'closed', 0);
        var postMax = _.get(_.maxBy(_.values(bins), 'post'), 'post', 0);
        if (newMax - closedMax > 1) {
            var yAxisMax1 = newMax;
        } else {
            var yAxisMax1 = closedMax;
        }

        const dateXform = (d) => {
            return this.gfDatePipe.transform(new Date(d), 'L');
        };

        return {
            chart: {
                type: 'multiChart',
                height: 315,
                margin: {
                    top: 10,
                    right: 50,
                    bottom: 40,
                    left: 40
                },
                showLegend: true,
                noData: this.gfTranslateService.translate("No Data Available"),
                showXAxis: true,
                showYAxis: true,
                x(d) {
                    return d.x;
                },
                y(d) {
                    return d.y;
                },
                xAxis: {
                    tickFormat(d) {
                        return dateXform(d);
                    }
                },
                //this keeps vertical bars at the bottom on any kind of datasets
                yDomain2: [(closedMax * -1) - (Math.ceil(yAxisMax1 / 10) + 1), Math.ceil((yAxisMax1 / 4) * (Math.ceil(yAxisMax1 / (10 + (Math.abs(newMax - closedMax) / 10))) + 10)) + 5],
                yAxis2: {
                    axisLabel: this.gfTranslateService.translate('Closed / New'),
                    tickFormat(d) {
                        return d;
                    }
                },
                //adds a little top margin for remaining chart line
                yDomain1: [0, Math.ceil(postMax * 1.1)],
                yAxis1: {
                    axisLabel: this.gfTranslateService.translate('Remaining'),
                    tickFormat(d) {
                        return d;
                    }
                },
                tooltip: true,
                transitionDuration: 1000
            }
        };
    }

    getBurndownChartData(burndown) {
        var bins = _.get(burndown, 'bins', {});
        var tickDate = function (dateKey) {
            var dt = new Date(dateKey + 'T00:00:00');
            var ticks = dt.getTime() + (dt.getTimezoneOffset() * 60000);
            return new Date(ticks);
        };
        return [
            {
                key: 'New Tasks',
                type: 'bar',
                yAxis: 2,
                values: Object.keys(bins).map(function (dateKey) {
                    return {
                        x: tickDate(dateKey),
                        y: bins[dateKey]['new']
                    };
                })
            },
            {
                key: 'Closed Tasks',
                type: 'bar',
                yAxis: 2,
                values: Object.keys(bins).map(function (dateKey) {
                    return {
                        x: tickDate(dateKey),
                        y: bins[dateKey]['closed'] * -1
                    };
                })
            },
            {
                key: 'Remaining Tasks',
                type: 'line',
                yAxis: 1,
                values: Object.keys(bins).map(function (dateKey) {
                    return {
                        x: tickDate(dateKey),
                        y: bins[dateKey]['post']
                    };
                })
            }
        ];
    }
}